import { useState } from 'react'
import { useTranslation } from 'react-i18next'

/** VH-225: link two exercises as variants of one movement without waiting for a suggestion. */
export default function ManualVariantLink({ exerciseNames, onLink, busy = false }) {
  const { t } = useTranslation()
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [switchDate, setSwitchDate] = useState('')
  const valid = from && to && from !== to

  const submit = (e) => {
    e.preventDefault()
    if (!valid) return
    onLink({ from_exercise_name: from, to_exercise_name: to, ...(switchDate ? { switch_date: switchDate } : {}) })
  }

  return (
    <form onSubmit={submit} className="bg-surface-container border rounded-lg p-3 text-sm space-y-2" data-testid="manual-variant-link">
      <h4 className="font-semibold">{t('trainingAnalysis.variants.manualTitle')}</h4>
      <div className="grid gap-2 sm:grid-cols-3">
        <label className="flex flex-col gap-1">
          <span className="text-xs text-gray-600">{t('trainingAnalysis.variants.from')}</span>
          <select value={from} onChange={(e) => setFrom(e.target.value)} className="border rounded px-2 py-1">
            <option value="">—</option>
            {exerciseNames.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs text-gray-600">{t('trainingAnalysis.variants.to')}</span>
          <select value={to} onChange={(e) => setTo(e.target.value)} className="border rounded px-2 py-1">
            <option value="">—</option>
            {exerciseNames.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs text-gray-600">{t('trainingAnalysis.variants.switchDate')}</span>
          <input type="date" value={switchDate} onChange={(e) => setSwitchDate(e.target.value)} className="border rounded px-2 py-1" />
        </label>
      </div>
      <button type="submit" disabled={!valid || busy} className="px-3 py-1 rounded bg-primary text-white disabled:opacity-50">
        {t('trainingAnalysis.variants.link')}
      </button>
    </form>
  )
}
